import Vue from 'vue';
import axios from "axios";
import store from './store';

Vue.prototype.$axios = axios;

const sendKdtsServerGet = function (path, data, cb) {
    axios.get(store.state.host.api + path, {
        params: data
    }).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}

const sendStatServerGet = function (path, data, cb) {
    axios.get(store.state.host.statApi + path, {
        params: data
    }).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}


const sendTanApi = function (path, data, cb) {
    axios.post(store.state.host.tanApi + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}

const sendKdtsServer = function (path, data, cb) {
    axios.post(store.state.host.kdtsApi + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}

const sendServer = function (path, data, cb) {
    axios.post(store.state.host.api + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}

const sendServerGet = function (path, data, cb) {
    axios.get(store.state.host.api + path, {
        params: data
    }).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}

const sendPay = function (path, data, cb) {
    axios.post(store.state.host.pay + path, data).then((response) => {
        cb ? cb(null, response.data) : null;
    }).catch((error) => {
        cb ? cb(error, null) : null;
    });
}

const req = {
    dev: {
        login: function (data, cb) {
            sendKdtsServerGet("/pt/dev/login", data, cb);
        },
        user: function (data, cb) {
            sendKdtsServerGet("/pt/dev/user", data, cb);
        },
        pid: function (data, cb) {
            sendStatServerGet("/dev/pid/query", data, cb);
        }
    },
    router: {
        server: {
            userInfo: function (data, cb) {
                sendKdtsServer("/c/query", data, cb);
            },
            try: {
                info: function (data, cb) {
                    sendKdtsServer("/c/try/query", data, cb);
                },
                open: function (data, cb) {
                    sendKdtsServer("/c/try/open", data, cb);
                },
            },
            goods: function (data, cb) {
                sendServer("/wcjs/kdts/goods", data, cb);
            },
            check: function (data, cb) {
                sendServer("/wcjs/kdts/query", data, cb);
            },
            status: function (data, cb) {
                sendKdtsServer("/c/status", data, cb);
            },
            open: function (data, cb) {
                sendKdtsServer("/c/open", data, cb);
            },
            lan: {
                find: function (data, cb) {
                    sendServer("/wcjs/lan/find", data, cb);
                }
            },
            user: {
                dev: function (data, cb) {
                    sendServerGet("/user/devs", data, cb);
                },
                updateDev: function (data, cb) {
                    sendServer("/user/devUpdate", data, cb);
                }
            },
            gift: function (data, cb) {
                sendKdtsServer("/c/gift", data, cb);
            },
            login: function (data, cb) {
                sendServer("/wx/account/auth", data, cb);
            }
        },
        log: {
            err: function (data, cb) {
                sendTanApi("/log/err", data, cb);
            },
            user: function (data, cb) {
                sendTanApi("/log/user", data, cb);
            }
        },
        pay: {
            sign: function (data, cb) {
                sendPay("/pay/UnifiedOrder", data, cb);
            },
            check: function (data, cb) {
                sendPay("/pay/OrderQuery", data, cb);
            }
        }
    },
    game: {
        list: function (data, cb) {
            sendServer("/game/list/games.json", data, cb);
        }
    }
}

export default req